export default __webpack_public_path__ + "static/media/align-left.1feab94d.svg";